import { Code } from '@mantine/core'

type ExtractionStringProps = {
  extraction: string
}

export const ExtractionString = ({ extraction }: ExtractionStringProps) => {
  return (
    <Code
      color="brand-primary.0"
      fz={11}
      styles={{ root: { wordBreak: 'break-all' } }}
    >
      {extraction}
    </Code>
  )
}
